import { get, post } from "@/utils/request"; // 导入模块


// 登录
export const userLogin = (params) =>
    post("Api/Login/Login/", params);

// 投递简历
export const SendResume = (params) =>
    get("Api/User/SendResume", params);

// 修改简历
export const ReUploadResume = (params) =>
    post("Api/User/ReUploadResume", params);

// 获取用户信息
export const GetUserInfo = (params) =>
    get("Api/User/GetUserInfo", params);




// // 登录
// export const userLogin = (params) =>
//     post("api/Api/Login/Login", params);

// // 投递简历
// export const SendResume = (params) =>
//     get("api/Api/User/SendResume", params);

// // 修改简历
// export const ReUploadResume = (params) =>
//     post("api/Api/User/ReUploadResume", params);